









































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import {
    activateConversations
} from '@/api/conversation'

import BaseButton from '@/components/BaseButton.vue'
import BaseFormRow from '@/components/BaseFormRow.vue'
import {Action, Getter} from 'vuex-class'
import Tracker from '@/pages/conversation/components/Tracker.vue'


@Component<UpgradeModal>({
    components: {
        Tracker,
        BaseButton,
        BaseFormRow
    }
})
export default class UpgradeModal extends Vue {
    @Getter public getIsBasic!: boolean
    @Getter public getHasBilling!: boolean
    @Action public setUpgradeConversations!: (boolean) => void

    public loaded = true
    public upgradePrice = 10000
    public state = 1

    public closeModal() {
        this.$emit('close')
    }

    // public getBilling(){
    //     return this
    // }

    public async buyUpgrade() {
        this.state = 2
        const {data: {success}} = await activateConversations()
        this.setUpgradeConversations(true)
        this.state = 3
    }

    // Load the MRR price
    public async mounted() {
        // const {data: {success, mrr}} = await getMrr()
        // const dollars = Math.floor(parseFloat(mrr) / 100)
        // this.loaded = true
        // this.upgradePrice = Math.max(100, Math.floor(dollars * 0.2))

    }
}
